module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }